// pages/UserInteractionFeed/BookmarksPage.tsx
import React from 'react';
import { useAuth } from '../../context/AuthContext';
import UserInteractionFeed from '../UserInteractionFeed/index';

const BookmarksPage: React.FC = () => {
  const { user } = useAuth();
  const username = user?.username ?? 'You';

  return (
    <UserInteractionFeed
      kind="BOOKMARKED"
      title={`${username} bookmarks`}
      emptyMessage="You haven’t bookmarked any posts yet."
    />
  );
};

export default BookmarksPage;
